import API_BASE_URL from "../../utils/apiBase";
import { useEffect, useState } from "react";
import "./dashboard.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { CiSearch } from "react-icons/ci";
import { toast } from "react-toastify";
import ExportToExcel from "../../utils/jsonToExcel";
import TablePop from "./TablePopup";
import LeftSideBar from "./SideBar";
import CalenderData from "./CalenderData";
import DashBoardData from "./DashRender";
import SalesData from "./SalesData";
import ChannelPartnerbyDate from "./channelpartner/channelPartner";
import LogoutButton from "../../Components/UI/logOut";
import ExportToExcelCPDate from "../../utils/jsonToExcelCPDate";
import ProjectsView from "./projects/ProjectsView";
import OverviewView from "./overview/OverviewView";
import RmView from "./rms/RmView";
import BrokersView from "./brokers/BrokersView";

const Dashboard = () => {
  const [isSelected, setIsSelected] = useState(false);
  // Opens on the charts overview; Recent Visits is one click away
  const [activeMenuItem, setActiveMenuItem] = useState("overview");
  const [activeTab, setActiveTab] = useState("customer"); // State variable to track active tab
  const [sortedData, setSortedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // Add state for filtered data
  const [searchQuery, setSearchQuery] = useState("");
  const [sourceTable,Setsource]=useState("")
  const [sovereigndata,setSovereignData]= useState([])
  const [saanverdanteData,setsSaanverdanteData]= useState([])

  const [dashData, setDashData] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: new Date().toISOString().split("T")[0], // Set default start date to current date
    endDate: new Date().toISOString().split("T")[0], // Set default end date to current date
  });
  const [channelPartnerDateRange, setChannelPartnerDateRange] = useState({
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
  });
  const [sovereignPake, SetovereignPake] = useState({
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
  });
    const [saanVerdante, setSaanVerdante] = useState({
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
  });
  // Function to handle start date change for ChannelPartnerbyDate component
  const handleChannelPartnerStartDateChange = (date) => {
    // Update the start date for ChannelPartnerbyDate component
    setChannelPartnerDateRange((prevRange) => ({
      ...prevRange,
      startDate: date,
    }));
  };
  // Function to handle end date change for ChannelPartnerbyDate component
  const handleChannelPartnerEndDateChange = (date) => {
    // Update the end date for ChannelPartnerbyDate component
    setChannelPartnerDateRange((prevRange) => ({
      ...prevRange,
      endDate: date,
    }));
  };
  const [selectedRow, setSelectedRow] = useState(null); // State variable to store selected row data
  const [showPopup, setShowPopup] = useState(false); // State variable to control popup visibility
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // State variable to track sidebar visibility
  const [rowSelect, setRowSelect] = useState("");
  const [imagePopUp , setImagePopUp]= useState();
  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  // JSX for sidebar content
  // Function to handle click on table row
  const handleRowClick = (rowData, index) => {
    setSelectedRow(rowData); // Set selected row data
    setSelectedRow(rowData === isSelected ? null : rowData);
    setShowPopup(true); 
    setIsSelected(true);
    setRowSelect(index);
  };
  
  // useEffect to fetch data from the API when the component mount
  const DashboardData = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/allData/get-latest`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json", // Provide headers as an object
          }
          
        }
      );
      const responseData = await response.json();
      const { data, message } = responseData;
      if (!response.ok) {
        throw new Error(`${message}`);
      }
      setSortedData(() => data); // Update state with fetched data using a callback
      if (response.ok) {
        toast.success(`${message}`);
        // console.log("Sorted data", sortedData);
      } else {
        toast.error(`${message}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData("");
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleStartDateChange = (date) => {
    if (date) {
      setDateRange((prevRange) => ({
        ...prevRange,
        startDate: date,
      }));
    } else {
      setDateRange((prevRange) => ({
        ...prevRange,
        startDate: "Please select a date",
      }));
    }
  };
  const handleEndDateChange = (date) => {
    if (date) {
      setDateRange((prevRange) => ({
        ...prevRange,
        endDate: date,
      }));
    } else {
      setDateRange((prevRange) => ({
        ...prevRange,
        endDate: "26/12/2024",
      }));
    }
  };

  const handleStartDateChangeSovereign = (date) => {
    if (date) {
      SetovereignPake((prevRange) => ({
        ...prevRange,
        startDate: date,
      }));
    } else {
      SetovereignPake((prevRange) => ({
        ...prevRange,
        startDate: "Please select a date",
      }));
    }
  };

  const handleEndDateChangeSovereign = (date) => {
    if (date) {
      // If a date is selected, update the start date
      SetovereignPake((prevRange) => ({
        ...prevRange,
        endDate: date,
      }));
    } else {
      // If no date is selected, keep the start date as empty string
      SetovereignPake((prevRange) => ({
        ...prevRange,
        endDate: "26/12/2024",
      }));
    }
  };


    const handleStartDateChangeSaanverdate = (date) => {
    if (date) {
      setSaanVerdante((prevRange) => ({
        ...prevRange,
        startDate: date,
      }));
    } else {
      setSaanVerdante((prevRange) => ({
        ...prevRange,
        startDate: "Please select a date",
      }));
    }
  };

  const handleEndDateChangeSaanverdate = (date) => {
    if (date) {
      // If a date is selected, update the start date
      setSaanVerdante((prevRange) => ({
        ...prevRange,
        endDate: date,
      }));
    } else {
      // If no date is selected, keep the start date as empty string
      setSaanVerdante((prevRange) => ({
        ...prevRange,
        endDate: "26/12/2024",
      }));
    }
  };
  // Search — one matcher shared by every dashboard view. It is applied when
  // each view renders, so fetched data is never mutated and clearing the box
  // restores the full list. Null-safe: revisit upserts can leave records
  // without a name or phone.
  const query = searchQuery.trim().toLowerCase();
  const matchesSearch = (item) => {
    if (!query) return true;
    if (typeof item === "string") return item.toLowerCase().includes(query);
    return [
      item?.name,
      item?.phoneNumber,
      item?.lastFiveDigit,
      item?.companyName,
      item?.cpEnrolled,
      item?.meetingWith,
      item?.createdBy,
      item?.placeOfVisit,
    ].some((value) => value != null && String(value).toLowerCase().includes(query));
  };
  // For { customer: [...], channelPartner: [...] } payloads
  const searchData = (data) => {
    if (!query || !data || typeof data !== "object") return data;
    return {
      ...data,
      customer: Array.isArray(data.customer) ? data.customer.filter(matchesSearch) : data.customer,
      channelPartner: Array.isArray(data.channelPartner)
        ? data.channelPartner.filter(matchesSearch)
        : data.channelPartner,
    };
  };
  // For the CP Date view's { date: [...] } groups; hides dates with no match
  const searchGroups = (groups) => {
    if (!query || !groups) return groups;
    return Object.fromEntries(
      Object.entries(groups)
        .map(([date, items]) => [date, items.filter(matchesSearch)])
        .filter(([, items]) => items.length > 0)
    );
  };

  // Recent Visits data. (This effect used to also reset the Vatika date
  // pickers to today on every keystroke and whenever Sovereign / Saan Verdante
  // state changed, and reset `sourceTable`, which nothing reads. Both removed.)
  useEffect(() => {
    if (sortedData?.customer?.length > 0) {
      setDashData({
        customer: sortedData.customer.filter(matchesSearch),
        channelPartner: (sortedData.channelPartner || []).filter(matchesSearch),
        multipleVisit: sortedData.customer.filter(
          (item) => Number(item.visitCount || 0) > 1
        ),
      });
    } else {
      setDashData({ customer: [], channelPartner: [], multipleVisit: [] });
    }
  }, [searchQuery, sortedData]);
  
  // Sorted data
  useEffect(() => {
    setSortedData(dashData);
  }, []);
  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  useEffect(() => {
    DashboardData();
  }, []); // Add an empty dependency array to ensure the effect runs only once when the component mounts

  const handleDateSubmit = async (source) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/allData/date`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            date: {
              startDate: dateRange.startDate,
              endDate: dateRange.endDate,
            },
            source
          }),
        }
      );
      const responseData = await response.json();
      const { data, message } = responseData;
      console.log(responseData)
      // console.log(sourceTable)
      if (!response.ok) {
        throw new Error(
          `${message} for ${new Date(
            dateRange.startDate
          ).toLocaleDateString()} & ${new Date(
            dateRange.endDate
          ).toLocaleDateString()}`
        );
      }
      setFilteredData(() => data);
     
      Setsource(() => data?.source);
      if (response.ok) {
        toast.success(
          `${message} for ${new Date(
            dateRange.startDate
          ).toLocaleDateString()} & ${new Date(
            dateRange.endDate
          ).toLocaleDateString()}`
        );
      } else {
        toast.error(
          `${message} for ${new Date(
            dateRange.startDate
          ).toLocaleDateString()} & ${new Date(
            dateRange.endDate
          ).toLocaleDateString()}`
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData("");
      toast.error(`Error: ${error.message}`);
    }
  };
    const handleDateSubmitSaanVerdantes = async (source) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/allData/date`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            date: {
              startDate: saanVerdante.startDate,
              endDate: saanVerdante.endDate,
            },
            source
          }),
        }
      );
      const responseData = await response.json();
      const { data, message } = responseData;
         Setsource(() => data?.source);
          setsSaanverdanteData(() => data); 
      if (!response.ok) {
        throw new Error(
          `${message} for ${new Date(
            saanVerdante.startDate
          ).toLocaleDateString()} & ${new Date(
            saanVerdante.endDate
          ).toLocaleDateString()}`
        );
      }
     
    

      if (response.ok) {
        toast.success(
          `${message} for ${new Date(
            saanVerdante.startDate
          ).toLocaleDateString()} & ${new Date(
            saanVerdante.endDate
          ).toLocaleDateString()}`
        );
      } else {
        toast.error(
          `${message} for ${new Date(
            saanVerdante.startDate
          ).toLocaleDateString()} & ${new Date(
            saanVerdante.endDate
          ).toLocaleDateString()}`
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData("");
      toast.error(`Error: ${error.message}`);
    }
  };
  const handleDateSubmitSoverign = async (source) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/allData/date`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            date: {
              startDate: sovereignPake.startDate,
              endDate: sovereignPake.endDate,
            },
            source
          }),
        }
      );
      const responseData = await response.json();
      const { data, message } = responseData;
      console.log(responseData)
      // console.log(sourceTable)
      if (!response.ok) {
        throw new Error(
          `${message} for ${new Date(
            sovereignPake.startDate
          ).toLocaleDateString()} & ${new Date(
            sovereignPake.endDate
          ).toLocaleDateString()}`
        );
      }
       Setsource(() => data?.source);
      setSovereignData(() => data);
      
      if (response.ok) {
        toast.success(
          `${message} for ${new Date(
            sovereignPake.startDate
          ).toLocaleDateString()} & ${new Date(
            dateRange.endDate
          ).toLocaleDateString()}`
        );
      } else {
        toast.error(
          `${message} for ${new Date(
            dateRange.startDate
          ).toLocaleDateString()} & ${new Date(
            dateRange.endDate
          ).toLocaleDateString()}`
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData("");
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleCPDateSubmit = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/allData/date`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            date: {
              startDate: channelPartnerDateRange.startDate,
              endDate: channelPartnerDateRange.endDate,
            },
          }),
        }
      );
      const responseData = await response.json();
      const { data, message } = responseData;
      groupDataByDate(data);
      if (!response.ok) {
        throw new Error(
          `${message} for ${new Date(
            dateRange.startDate
          ).toLocaleDateString()} & ${new Date(
            dateRange.endDate
          ).toLocaleDateString()}`
        );
      }
      // setFilteredData(() => data); // Update state with fetched data using a callback
      if (response.ok) {
        toast.success(
          `${message} for ${new Date(
            dateRange.startDate
          ).toLocaleDateString()} & ${new Date(
            dateRange.endDate
          ).toLocaleDateString()}`
        );
      } else {
        toast.error(
          `${message} for ${new Date(
            dateRange.startDate
          ).toLocaleDateString()} & ${new Date(
            dateRange.endDate
          ).toLocaleDateString()}`
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredData("");
      toast.error(`Error: ${error.message}`);
    }
  };
  // Render customer data if active tab is "customer", otherwise render channel partner data
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Set the active tab
  
    // Get tab elements
    let tabNameCustomer = document.getElementById("tab_name_customer");
    let tabNameCP = document.getElementById("tab_name_cp");
    let multivisit = document.getElementById("tab_vatika_multivisit");
  
    // Reset all tabs to default styles
    [tabNameCustomer, tabNameCP, multivisit].forEach((tabElement) => {
      if (tabElement) {
        tabElement.style.color = "";
        tabElement.style.fontSize = "15px";
        tabElement.style.fontWeight = "normal";
      }
    });
  
    // Apply active styles to the clicked tab
    let activeTabElement = 
      tab === "customer"
        ? tabNameCustomer
        : tab === "multivisit"
        ? multivisit
        : tabNameCP;
  
    if (activeTabElement) {
      activeTabElement.style.color = "#daa520";
      activeTabElement.style.fontSize = "17px";
      activeTabElement.style.fontWeight = "bold";
    }
  };
  
  const [dashTab, setDashTab] = useState("customer");
  const handleDashClick = (tab) => {
    setDashTab(tab);
    let tabNameCP = document.getElementById("tab_name_cp");
    let tabNameCustomer = document.getElementById("tab_name_customer");
    if (tab === "customer") {
      tabNameCP.style.color = "";
      tabNameCP.style.fontSize = "15px";
      tabNameCP.style.fontWeight = "";
      tabNameCustomer.style.color = "#daa520";
      tabNameCustomer.style.fontSize = "#daa520";
      tabNameCustomer.style.fontWeight = "#daa520";
    }
    else if (tab === "customer-sovereign") {
      tabNameCP.style.color = "";
      tabNameCP.style.fontSize = "15px";
      tabNameCP.style.fontWeight = "";
      tabNameCustomer.style.color = "#daa520";
      tabNameCustomer.style.fontSize = "#daa520";
      tabNameCustomer.style.fontWeight = "#daa520";
    }
    
     else {
      tabNameCP.style.color = "#daa520";
      tabNameCP.style.fontSize = "#daa520";
      tabNameCP.style.fontWeight = "#daa520";
      tabNameCustomer.style.color = "";
      tabNameCustomer.style.fontSize = "15px";
      tabNameCustomer.style.fontWeight = "";
    }
  };
  const [customerwithCP, setCustomerwithCP] = useState([]);
  const [customerwithoutCP, setCustomerwithoutCP] = useState([]);
  const groupDataByDate = (data) => {
    let sortedData = [...data.customer].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    const groupedCustomerData = sortedData.reduce(
      (acc, { name, cpEnrolled, createdAt }) => {
        if (!acc[createdAt]) {
          acc[createdAt] = [];
        }

        acc[createdAt].push({ name, cpEnrolled: cpEnrolled || null });

        return acc;
      },
      {}
    );

    const customerWithCP = {};
    const channelPartnerWithoutCustomers = {};

    for (const [date, customers] of Object.entries(groupedCustomerData)) {
      customerWithCP[date] = customers.filter(
        (customer) => customer.cpEnrolled
      );
    }

    // Sort channel partners by date
    const sortedChannelPartners = [...data.channelPartner].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    for (const channelPartner of sortedChannelPartners) {
      const date = channelPartner.createdAt.split("T")[0]; 
      if (!channelPartnerWithoutCustomers[date]) {
        channelPartnerWithoutCustomers[date] = [];
      }

      if (
        channelPartner.customer.length === 0 &&
        channelPartner.customerNames.length === 0
      ) {
        const formattedName = `${channelPartner.companyName} -- ${channelPartner.name}`;
        channelPartnerWithoutCustomers[date].push(formattedName);
      }
    }

    console.log(
      "channelPartnerWithoutCustomers",
      channelPartnerWithoutCustomers
    );

    setCustomerwithCP(customerWithCP);
    setCustomerwithoutCP(channelPartnerWithoutCustomers);
  };

  const renderDashboardContent = () => {
    return (
      <>
        {activeMenuItem === "dashboard" && (
          <div className='table'>
            <div className='tabs'>
              <div className='tab_name'>
                <p
                  id='tab_name_customer'
                  onClick={() => handleDashClick("customer")}
                  className={dashTab === "customer" ? "is-active" : undefined}
                >
                  Customer
                </p>
                <p
                  id='tab_name_cp'
                  onClick={() => handleDashClick("channelPartner")}
                  className={dashTab === "channelPartner" ? "is-active" : undefined}
                >
                  Channel Partner
                </p>
              </div>
              <ExportToExcel data={sortedData} />
              <div className='three_dots'>
                <i className='bx bx-dots-vertical-rounded'></i>
              </div>{" "}
            </div>
            <DashBoardData
              dashData={dashData}
              activeTab={dashTab}
              handleRowClick={handleRowClick}
              rowSelect={rowSelect}
            />
          </div>
        )}
        {activeMenuItem === "calendar-vatika" && (
          <div className='reservation-box'>
            <div className='top'>
              <div className='static'>
                <div className='input-container' id='date-picker-container'>
                  <label>From</label>
                  <input
                    type='date'
                    id='date-checkin'
                    className='date-field'
                    name={`${dateRange.startDate}`}
                    value={dateRange.startDate}
                    onChange={(e) => handleStartDateChange(e.target.value)}
                  />
                </div>
              </div>
              <div className='flex'>
                <div className='input-container' id='date-picker-container'>
                  <label>To</label>
                  <input
                    type='date'
                    id='date-checkout'
                    className='date-field'
                    name={`${dateRange.endDate}`}
                    value={dateRange.endDate}
                    onChange={(e) => handleEndDateChange(e.target.value)}
                  />
                </div>
                <div className='button-container'>
                  <span className='button ok' onClick={()=>handleDateSubmit('vatika')}>
                    Fetch Data
                  </span>
                </div>
              </div>
            </div>
            <div className='table'>
              <div className='tabs'>
                <div className='tab_name'>
                  <p
                    id='tab_name_customer'
                    onClick={() => handleTabClick("customer")}
                    className={activeTab === "customer" ? "is-active" : undefined}
                  >
                    Customer
                  </p>
                  <p
                    id='tab_name_cp'
                    onClick={() => handleTabClick("channelPartner")}
                    className={activeTab === "channelPartner" ? "is-active" : undefined}
                  >
                    Channel Partner
                  </p>
                  <p
                    id='tab_vatika_multivisit'
                    onClick={() => handleTabClick("multivisit")}
                    className={activeTab === "multivisit" ? "is-active" : undefined}
                  >
                    Multiple Visit
                  </p>
                  {Object.keys(filteredData).length > 0 && (
                    <ExportToExcel data={filteredData} />
                  )}
                </div>
                <div className='three_dots'>
                  <i className='bx bx-dots-vertaical-rounded'></i>
                </div>{" "}
              </div>
              <CalenderData
                dashData={searchData(filteredData)}
                activeTab={activeTab}
                handleRowClick={handleRowClick}
                rowSelect={rowSelect}
              />
            </div>
          </div>
        )}
          {activeMenuItem === "calendar-sovereign" && (
          <div className='reservation-box'>
            <div className='top'>
              <div className='static'>
                <div className='input-container' id='date-picker-container'>
                  <label>From</label>
                  <input
                    type='date'
                    id='date-checkin'
                    className='date-field'
                    name={`${sovereignPake.startDate}`}
                    value={sovereignPake.startDate}
                    onChange={(e) => handleStartDateChangeSovereign(e.target.value)}
                  />
                </div>
              </div>
              <div className='flex'>
                <div className='input-container' id='date-picker-container'>
                  <label>To</label>
                  <input
                    type='date'
                    id='date-checkout'
                    className='date-field'
                    name={`${sovereignPake.endDate}`}
                    value={sovereignPake.endDate}
                    onChange={(e) => handleEndDateChangeSovereign(e.target.value)}
                  />
                </div>
                <div className='button-container'>
                  <span className='button ok' onClick={()=>handleDateSubmitSoverign('sovereign')}>
                    Fetch Data
                  </span>
                </div>
              </div>
            </div>
            <div className='table'>
              <div className='tabs'>
                <div className='tab_name'>
                  <p
                    id='tab_name_customer'
                    onClick={() => handleTabClick("customer-sovereign")}
                    className={activeTab === "customer-sovereign" ? "is-active" : undefined}
                  >
                    Customer
                  </p>
                  <p
                    id='tab_name_cp'
                    onClick={() => handleTabClick("channelPartner")}
                    className={activeTab === "channelPartner" ? "is-active" : undefined}
                  >
                    Channel Partner
                  </p>
                  <p
                    id='tab_vatika_multivisit'
                    onClick={() => handleTabClick("multivisit")}
                    className={activeTab === "multivisit" ? "is-active" : undefined}
                  >
                    Multiple Visit
                  </p>
                  {Object.keys(sovereigndata).length > 0 && (
                    <ExportToExcel data={sovereigndata} />
                  )}
                </div>
                <div className='three_dots'>
                  <i className='bx bx-dots-vertical-rounded'></i>
                </div>{" "}
              </div>
              <CalenderData
                dashData={searchData(sovereigndata)}
                activeTab={activeTab}
                handleRowClick={handleRowClick}
                rowSelect={rowSelect}
              />
            </div>
          </div>
        )}
        {activeMenuItem === "calendar-saan-verdante" && (
          <div className='reservation-box'>
            <div className='top'>
              <div className='static'>
                <div className='input-container' id='date-picker-container'>
                  <label>From</label>
                  <input
                    type='date'
                    id='date-checkin'
                    className='date-field'
                    name={`${saanVerdante.startDate}`}
                    value={saanVerdante.startDate}
                    onChange={(e) => handleStartDateChangeSaanverdate(e.target.value)}
                  />
                </div>
              </div>
              <div className='flex'>
                <div className='input-container' id='date-picker-container'>
                  <label>To</label>
                  <input
                    type='date'
                    id='date-checkout'
                    className='date-field'
                    name={`${saanVerdante.endDate}`}
                    value={saanVerdante.endDate}
                    onChange={(e) => handleEndDateChangeSaanverdate(e.target.value)}
                  />
                </div>
                <div className='button-container'>
                  <span className='button ok' onClick={()=>handleDateSubmitSaanVerdantes('sannverdante')}>
                    Fetch Data
                  </span>
                </div>
              </div>
            </div>
            <div className='table'>
              <div className='tabs'>
                <div className='tab_name'>
                  <p
                    id='tab_name_customer'
                    onClick={() => handleTabClick("customer")}
                    className={activeTab === "customer" ? "is-active" : undefined}
                  >
                    Customer
                  </p>
                  <p
                    id='tab_name_cp'
                    onClick={() => handleTabClick("channelPartner")}
                    className={activeTab === "channelPartner" ? "is-active" : undefined}
                  >
                    Channel Partner
                  </p>
                  <p
                    id='tab_vatika_multivisit'
                    onClick={() => handleTabClick("multivisit")}
                    className={activeTab === "multivisit" ? "is-active" : undefined}
                  >
                    Multiple Visit
                  </p>
                  {Object.keys(saanverdanteData).length > 0 && (
                    <ExportToExcel data={saanverdanteData} />
                  )}
                </div>
                <div className='three_dots'>
                  <i className='bx bx-dots-vertaical-rounded'></i>
                </div>{" "}
              </div>
              <CalenderData
                dashData={searchData(saanverdanteData)}
                activeTab={activeTab}
                handleRowClick={handleRowClick}
                rowSelect={rowSelect}
              />
            </div>
          </div>
        )}
        {activeMenuItem === "projects" && (
          <ProjectsView
            searchData={searchData}
            handleRowClick={handleRowClick}
            rowSelect={rowSelect}
          />
        )}
        {/* An admin-added project's own page, opened from its sidebar entry */}
        {activeMenuItem.startsWith("project:") && (
          <ProjectsView
            key={activeMenuItem}
            lockedProject={activeMenuItem.slice("project:".length)}
            onRenamed={(newName) => setActiveMenuItem(`project:${newName}`)}
            searchData={searchData}
            handleRowClick={handleRowClick}
            rowSelect={rowSelect}
          />
        )}
        {activeMenuItem === "Users" && (
          <div className='reservation-box'>
            <div className='top'>
              <SalesData searchQuery={searchQuery} />
            </div>
          </div>
        )}
        {activeMenuItem === "rms" && <RmView searchQuery={searchQuery} />}
        {activeMenuItem === "brokers" && <BrokersView searchQuery={searchQuery} />}
        {activeMenuItem === "Channel-Partner" && (
          <div className='reservation-box'>
            <div className='top'>
              <div className='static'>
                <div className='input-container' id='date-picker-container'>
                  <label>From</label>
                  <input
                    type='date'
                    id='date-checkin'
                    className='date-field'
                    name={`${channelPartnerDateRange.startDate}`}
                    value={channelPartnerDateRange.startDate}
                    onChange={(e) =>
                      handleChannelPartnerStartDateChange(e.target.value)
                    }
                  />
                </div>
              </div>
              <div className='flex'>
                <div className='input-container' id='date-picker-container'>
                  <label>To</label>
                  <input
                    type='date'
                    id='date-checkout'
                    className='date-field'
                    name={`${channelPartnerDateRange.endDate}`}
                    value={channelPartnerDateRange.endDate}
                    onChange={(e) =>
                      handleChannelPartnerEndDateChange(e.target.value)
                    }
                  />
                </div>
                <div className='button-container'>
                  <span className='button ok' onClick={handleCPDateSubmit}>
                    Fetch Data
                  </span>
                </div>
              </div>
            </div>

            <div className='table'>
              <ExportToExcelCPDate
                customerwithCP={customerwithCP}
                customerwithoutCP={customerwithoutCP}
              />
              <ChannelPartnerbyDate
                customerwithCP={searchGroups(customerwithCP)}
                customerwithoutCP={searchGroups(customerwithoutCP)}
              />
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <div className='dash-container '>
      <LeftSideBar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        activeMenuItem={activeMenuItem}
        setActiveMenuItem={(item) => {
          setActiveMenuItem(item);
          setIsSidebarOpen(false); // on the phone/tablet drawer, picking a page closes it
        }}
      />
      {/* Drawer mode only (CSS): dims the page and closes the drawer on tap */}
      {isSidebarOpen && (
        <div className='drawer-backdrop' aria-hidden='true' onClick={() => setIsSidebarOpen(false)} />
      )}
      <div className='main_content'>
        <LogoutButton className='dash-logout' />
        <div className='left_right_sidebar_opener'>
          <div className='hamburger' onClick={toggleSidebar}>
            <GiHamburgerMenu />
          </div>
        </div>
        {/* Search filters the list views; the Overview has nothing to search */}
        {activeMenuItem !== "overview" && (
        <div className='menu_item_name_and_filter '>
          <div className='main_navbar'>
            <div className='search_box'>
              <i className='bx bx-search-alt-2'></i>{" "}
              <input
                type='text '
                placeholder='Search name, phone, CP, sales person…'
                value={searchQuery}
                onChange={handleSearchInputChange}
              />
              <div className='dark_mode_icon'>
                <CiSearch />
              </div>
            </div>
          </div>
        </div>
        )}
        {activeMenuItem === "overview" && <OverviewView />}
        {renderDashboardContent()}
        
        {showPopup && (
          <TablePop
            data={selectedRow}
            setShowPopup={setShowPopup}
            date={selectedRow.date}
            setRowSelect={setRowSelect}
          />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
